import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { ValuationEventTaskDto } from 'src/app/modules/raci/models/valuation-event-task-dto';
import { RaciService } from 'src/app/modules/raci/services/raci.service';
import { RaciNavigationService } from '../../../../navigation/raci-navigation.service';

/**
 * Handles the valuation event setup form component
 */
@Component({
  selector: 'valuation-event-setup-form',
  templateUrl: './valuation-event-setup-form.component.html',
  styleUrls: ['./valuation-event-setup-form.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ValuationEventSetupFormComponent implements OnDestroy {
  /**
  * The valuation event ID
  */
  valuationEventId: any;

  /**
   * Observable for valuation event basic details
   */
  veBasicDetails$: Observable<ValuationEventTaskDto>;

  /**
   * Valuation event basic details
   */
  veBasicDetails: ValuationEventTaskDto;

  /**
   * Indicates whether to show title information
   */
  @Input() showTitleInfo = false;

  /**
   * Setter for portfolio ID
   */
  @Input() set portfolioId(value: any) {
    if (value) {
      this.valuationEventId = value;
      this.getData();
    }
  }

  /**
   * Disable fields editing
   */
  @Input() disableEditing: boolean;

  /**
   * Array of subscriptions
   */
  private _subscriptions: Array<Subscription> = new Array<Subscription>();

  /**
   * Constructor
   * @param _raciService RaciService
   * @param _raciNavigationService RaciNavigationService
   */
  constructor(private _raciService: RaciService,
              private _raciNavigationService: RaciNavigationService) { }

  /**
   * Get date for valuation event
   */
  getData() {
    this.veBasicDetails$ = this._raciService.getVEBasicTaskDetails(this.valuationEventId);
    this._subscriptions.push(this.veBasicDetails$.subscribe(data => {
      this.veBasicDetails = data;
      this._raciNavigationService.setActiveValuationEventSetup(this.veBasicDetails);
    }));
  }


  /**
   * Detect changes on fields
   * @param field Valuation event field
   * @param value Field value
   */
  detectChange(field: any, value: any) {
    this.veBasicDetails[field] = value;
    this._raciNavigationService.setActiveValuationEventSetup(this.veBasicDetails);
  }

  /**
   * On save event
   * @param details Valuation event details
   */
  onSave(details: ValuationEventTaskDto) {
    this._raciService.saveVEBasicTaskDetails(details).subscribe();
  }

  /**
   * On destroy
   * */
  ngOnDestroy(): void {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }
}
